import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://qcomcvxslvauprnsisli.supabase.co"; 

const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFjb21jdnhzbHZhdXBybnNpc2xpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzE4MzEyOTIsImV4cCI6MjA0NzQwNzI5Mn0.mJIqByaFX62di8lIVb6_63R6UWZihIDM6AhOmiAim74"; 

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
